
<component :is="tag">
  {{ tweenedNumber }}
</component>
